import { defineStore } from "pinia"
import { ref } from "vue"

export interface SuggestedTask {
  title: string
  category?: string
  priority?: string
  due_at?: string | null
  repeat_rule?: string | null
  project_id?: number | null
}

/*
 * Cross-component bus for the AI task confirm bottom sheet. The AI page
 * dispatches `request(task)`; AiTaskConfirmSheet listens and pops open.
 */
export const useAiTaskConfirmStore = defineStore("aiTaskConfirm", () => {
  const pending = ref<SuggestedTask | null>(null)
  const onAccepted = ref<(() => void) | null>(null)

  function request(task: SuggestedTask, accepted?: () => void) {
    pending.value = task
    onAccepted.value = accepted || null
  }
  function dismiss() {
    pending.value = null
    onAccepted.value = null
  }
  function accepted() {
    onAccepted.value?.()
    dismiss()
  }

  return { pending, request, dismiss, accepted }
})
